<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Add User</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Form -->
            <div class="form-group mb-3">
              <label for="full-name">Name</label>
              <input class="form-control" type="text" v-model="name" />
            </div>

            <div class="form-group mb-3">
              <label for="full-name">Position</label>
              <input class="form-control" type="text" v-model="position" />
            </div>

            <div class="form-group mb-3">
              <label for="role">Role</label>
              <br />
              <div class="form-check">
                <label class="checkbox-inline" v-for="(cur_role, index) in current_roles" :key="index">
                  <input type="checkbox" v-model="roles" :value="cur_role.value" /> {{cur_role.name}}
                  &nbsp; &nbsp; &nbsp;
                </label>
              </div>
            </div>
            <hr />

            <div class="form-group mb-3">
              <label for="email">Email</label>
              <input class="form-control" type="email" v-model="email" />
            </div>

            <div class="form-group mb-3">
              <label for="email">Username</label>
              <input class="form-control" type="text" v-model="username" />
            </div>

            <div class="form-group mb-3">
              <label for="password">Password</label>
              <input class="form-control" type="password" v-model="password" />
            </div>

            <div class="form-group mb-3">
              <label for="password_confirm">Confirm Password</label>
              <input
                class="form-control"
                type="password"
                v-model="password_confirmation"
              />
            </div>

            <!-- Button -->
            <div class="text-center">
              <button
                @click="add_new_staff()"
                class="btn btn-rounded btn-primary"
                style="width: 100px;"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "add_staff",
  components: {},
  data() {
    return {
      current_roles: [
        {value: 2, name: 'TBA Staff'},
        {value: 3, name: 'TBK Staff'},
        {value: 4, name: 'Administrator'},
        {value: 5, name: 'Marketing'},
        {value: 6, name: 'Finance'},
        {value: 7, name: 'General'},
        {value: 8, name: 'Claim'},
        {value: 9, name: 'Call Centre'},
      ],
      roles: [],
      role: [],
      new_data: [],
      name: "",
      email: "",
      username: "",
      password: "",
      password_confirmation: "",
      position: ""
    };
  },

  methods: {
    add_new_staff() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/staffs/add_staff",
                {
                  name: this.name,
                  email: this.email,
                  password: this.password,
                  password_confirmation: this.password_confirmation,
                  role: this.roles,
                  // role: [2,3],
                  position: this.position,
                  username: this.username
                },
                // axios.interceptors.request.use(request => {
                //     console.log(request)
                //     return request
                //   }),
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )

              .then(res => {
                if (res.data.authorised === true) {
                  if (res.data.success === true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                } else {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    // addNewRow() {
    //     this.role.push({
    //     });
    // },

    // deleteRow(index, value) {
    //     var idx = this.role.indexOf(value);
    //     console.log(idx, index);
    //     if (idx > -1) {
    //         this.role.splice(idx, 1);
    //     }
    //     // this.calculateTotal();
    // },

    loadAllData() {}
  },
  mounted() {
    this.loadAllData();
  }
};
</script>
